import * as Types from '../../../util/graphql/api.graphql';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';

export const CreateTaskDocument = gql`
  mutation CreateTask(
    $datasetId: String!
    $forRef: String!
    $note: String!
    $observationReference: String!
    $output: [TaskOutputIn!]
  ) {
    createTask(
      task: {
        resourceType: Task
        meta: {
          tag: [
            { code: $datasetId, system: "http://lifeomic.com/fhir/dataset" }
            {
              code: "LifeOmic Variant Selection"
              system: "http://lifeomic.com/fhir/source"
            }
          ]
        }
        code: { coding: [{ system: "http://loinc.org/", code: "LL1037-2" }] }
        status: draft
        intent: "proposal"
        for: { reference: $forRef }
        note: [{ text: $note }]
        input: [
          {
            type: {
              text: "Genetic variant assessment"
              coding: {
                code: "69548-6"
                system: "http://loinc.org"
                display: "Genetic variant assessment"
              }
            }
            valueReference: { reference: $observationReference }
          }
        ]
        output: $output
      }
    ) {
      id
      __typename
      code {
        coding {
          system
          code
        }
      }
      status
      intent
      for {
        reference
      }
      note {
        text
      }
      lastModified
      input {
        type {
          text
          coding {
            code
            system
            display
          }
        }
        valueReference {
          reference
        }
      }
      output {
        type {
          text
          coding {
            code
            system
            display
          }
        }
        valueString
      }
    }
  }
`;
export type CreateTaskMutationFn = ApolloReactCommon.MutationFunction<
  CreateTaskMutationResponse,
  CreateTaskMutationVariables
>;

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      datasetId: // value for 'datasetId'
 *      forRef: // value for 'forRef'
 *      note: // value for 'note'
 *      observationReference: // value for 'observationReference'
 *      output: // value for 'output'
 *   },
 * });
 */
export function useCreateTaskMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateTaskMutationResponse,
    CreateTaskMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreateTaskMutationResponse,
    CreateTaskMutationVariables
  >(CreateTaskDocument, baseOptions);
}
export type CreateTaskMutationHookResult = ReturnType<
  typeof useCreateTaskMutation
>;
export type CreateTaskMutationResult =
  ApolloReactCommon.MutationResult<CreateTaskMutationResponse>;
export type CreateTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateTaskMutationResponse,
  CreateTaskMutationVariables
>;
export type CreateTaskMutationVariables = Types.Exact<{
  datasetId: Types.Scalars['String'];
  forRef: Types.Scalars['String'];
  note: Types.Scalars['String'];
  observationReference: Types.Scalars['String'];
  output?: Types.Maybe<Array<Types.TaskOutputIn>>;
}>;

export type CreateTaskMutationResponse = {
  __typename: 'Mutation';
  createTask: {
    __typename: 'Task';
    id?: Types.Maybe<string>;
    status: Types.TaskStatus;
    intent: string;
    lastModified?: Types.Maybe<string>;
    code?: Types.Maybe<{
      __typename: 'CodeableConcept';
      coding?: Types.Maybe<
        Array<{
          __typename: 'Coding';
          system?: Types.Maybe<string>;
          code?: Types.Maybe<string>;
        }>
      >;
    }>;
    for?: Types.Maybe<{
      __typename: 'Reference';
      reference?: Types.Maybe<string>;
    }>;
    note?: Types.Maybe<
      Array<{ __typename: 'Annotation'; text?: Types.Maybe<string> }>
    >;
    input?: Types.Maybe<
      Array<{
        __typename: 'TaskInput';
        type: {
          __typename: 'CodeableConcept';
          text?: Types.Maybe<string>;
          coding?: Types.Maybe<
            Array<{
              __typename: 'Coding';
              code?: Types.Maybe<string>;
              system?: Types.Maybe<string>;
              display?: Types.Maybe<string>;
            }>
          >;
        };
        valueReference?: Types.Maybe<{
          __typename: 'Reference';
          reference?: Types.Maybe<string>;
        }>;
      }>
    >;
    output?: Types.Maybe<
      Array<{
        __typename: 'TaskOutput';
        valueString?: Types.Maybe<string>;
        type: {
          __typename: 'CodeableConcept';
          text?: Types.Maybe<string>;
          coding?: Types.Maybe<
            Array<{
              __typename: 'Coding';
              code?: Types.Maybe<string>;
              system?: Types.Maybe<string>;
              display?: Types.Maybe<string>;
            }>
          >;
        };
      }>
    >;
  };
};
